import { Component } from 'react';
import DataCacheService from '@/shared/services/DataCacheService';
import CurrencySymbols from '@/shared/currencySymbols';

class CurrencySymbol extends Component {
  state = {
    currencySymbol: '€',
  };

  componentDidMount() {
    let currencyCode = 'EUR';

    const cache = DataCacheService.getDataCache();

    if (cache) {
      ({ currencyCode } = cache.defaultcompany);

      const currencySymbol = CurrencySymbols.getByCurrencyCode(currencyCode);
      this.setState({ currencySymbol });
    }
  }

  render() {
    const { currencySymbol } = this.state;

    return currencySymbol;
  }
}

export default CurrencySymbol;
